import { constants } from '../../../constants/constants';
import {lazyReload} from "../../../lazyReload";
const ActiveCampaign = lazyReload(() => import('../../../../managers/activeCampaign/ActiveCampaign'));
const AutoCampaignPage = lazyReload(() => import('../../../../managers/autoCampaign/AutoCampaign'));

export const AutoCampaign = [
    {path: `/${constants.pages.autoCampaignUrl}/:buildingID`, component: ActiveCampaign, exact: true},
    {path: `/${constants.pages.autoCampaignPage}/:buildingID`, component: AutoCampaignPage, exact: true},
];
